import { Component, Input } from '@angular/core';

import { MatProgressBarModule } from '@angular/material/progress-bar';


@Component({
  selector: 'app-waiting-popup',
  imports: [
    MatProgressBarModule
  ],
  templateUrl: './waiting-popup.component.html',
  styleUrl: './waiting-popup.component.css'
})
export class WaitingPopupComponent {

  // Input parameters. Pass from the caller class binding the input through the HTML
  @Input() waitingMessage:string = '';

}
